module.exports = __webpack_public_path__ + "static/media/consultorio3.4dcbcc76.jpg";